import { createReducer, getUpdater } from '@advanza/advanza_generic'
import { changeEntity, changeFilter, invalidateFilters, receiveList } from './sharedReducerHandlers'

const update = getUpdater()

const handlers = {
    KEYWORDS_REQUEST: (state) =>
        update(state, {
            isFetching: { $set: true },
        }),
    KEYWORDS_RECEIVE_LIST: receiveList,
    KEYWORDS_CHANGE_FILTER: changeFilter,
    CHANGE_ENTITY_KEYWORDS: changeEntity,
    INVALIDATE_KEYWORDS: invalidateFilters,
}

const initialState = {
    isFetching: false,
    didInvalidate: false,
    entities: {},
    result: {},
    counts: {},
    filters: {},
}

export default createReducer(initialState, handlers)
